import * as Delta from 'quill-delta/dist/Delta'
import * as Quill from "quill";
import {Auth, LocalID} from "@/js/caller";

const Block     = Quill.import('blots/block');
const Parchment = Quill.import('parchment');

class BlockComment extends Block {
  static blotName  = "explain-block"
  static className = "ql-explain-block"
  static tagName   = "DIV"
  
  constructor(...args) {
    const sup = super(...args);
    this._updateClasses(this.domNode);
    return sup
  }
  
  create(value) {
    const domNode = super.create(value);
    this._updateClasses(domNode);
    return domNode
  }
  
  _updateClasses(domNode) {
    domNode.className = "ql-explain-block p-3 img-thumbnail"
  }
  
  optimize(context) {
    if (!this.domNode.textContent.endsWith('\n')) {
      this.appendChild(Parchment.create('text', '\n'));
    }
    super.optimize(context);
    let next = this.next;
    if (next != null && next.prev === this &&
      next.statics.blotName === this.statics.blotName &&
      this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
      next.optimize(context);
      next.moveChildren(this);
      next.remove();
    }
  }
}

const _switch = false
listenOnClassFunction(BlockComment)

function listenOnClassFunction(classFunction) {
  if (!_switch) return;
  
  function getAllMethods(obj, depth = 0) {
    if (depth < 0) return []
    const ProtoObject = (obj instanceof Function) ? obj.prototype : obj.__proto__
    return Object
      .getOwnPropertyNames(ProtoObject)
      .filter(k => k !== "constructor" && ProtoObject[k] instanceof Function)
      .concat(...getAllMethods(ProtoObject, depth - 1))
      .filter((value, index, self) => self.indexOf(value) === index)
  }
  
  //Get Super Functions
  const protoMethodsList = getAllMethods(classFunction, 3)
  protoMethodsList.forEach(function(k) {
    const superFunction        = classFunction.prototype[k]
    classFunction.prototype[k] = function(...args) {
      console.log(classFunction.name + "." + (superFunction.name || k) + " called");
      return superFunction.call(this, ...args)
    }
  })
}

Quill.register(BlockComment)

function getContent(el) {
  return Array
    .from(el.children)
    .map(el => ["UL", "OL"].includes(el.tagName) ? getContent(el) : el.textContent).join("\n")
}

function getRangeContent(el, index, length) {
  const content = getContent(el);
  const ext     = (content.slice(index, index + length).match(/\n/g) || []).length
  return content.slice(index, index + length + ext)
}

function getTrimSelection(el, index, length) {
  const content = getContent(el);
  if (content[index] === " ") return getTrimSelection(el, index + 1, length);
  const ext = (content.slice(index, index + length).match(/\n/g) || []).length
  if (content[index + length + ext - 1] === " ") return getTrimSelection(el, index, length - 1);
  return {
    range: {index, length},
    text : content.slice(index, index + length + ext)
  }
}

function replaceElem(quill, index, length, rText) {
  updateQuill(quill, index, length, rText)
}

function addCorrection(quill, error, correction, comment) {
  if (!comment) return;
  const block = 'explain-block'
  let index   = getExplanationBlockIndex(quill)
  const ops   = new SkipDelta()
    .retain(index === -1 ? quill.getLength() : index - 1)
    .skipIf(index !== -1).insert(
      "\nExplications\n",
      {"header": 3, "bold": true, "color": "#007bff"})
    .skipIf(index === -1).insert(
      "\n \n",
      {[block]: true})
    .insert(
      correction + "\n",
      {[block]: true, "bold": true, "color": "#007bff"}
    )
    .insert(
      comment,
      {[block]: true}
    )
    .skipIf(index !== -1, 2)
    .insert("\n", {[block]: true})
    .insert(" ")
  quill.updateContents(ops)
}

function updateQuill(quill, index, length, value) {
  const delta = new Delta()
    .retain(index)
    .delete(length)
    .insert(value, {bold: true, color: '#e60000'})
  quill.updateContents(delta)
}

function getExplanationBlockIndex(quill) {
  for (let i = quill.getLength(); i >= 0; i--) {
    const format = quill.getFormat(i);
    if (format["explain-block"]) return i
  }
  return -1
}

// Skip Delta
class SkipDelta extends Delta {
  _skipNext  = false
  _opsToSkip = 0
  
  constructor() {
    super();
    this._skipCapsule("insert")
  }
  
  _skipCapsule(functionName) {
    this[functionName] = (...args) => {
      if (!this._skipNext) {
        return super[functionName](...args)
      }
      this._skipNext = --this._opsToSkip !== 0
      return this
    }
  }
  
  skipIf(condition, opsToSkip = 1) {
    this._skipNext  = condition
    this._opsToSkip = opsToSkip
    return this
  }
}

// To text
function htmlToLines(html = "") {
  return html
    .replace(/<p>/g, '')
    .replace(/<\/p>/g, '\n')
    .replace(/<br>/g, ' \n')
    .split('\n')
    .filter(t => t !== "")
}

function getType(type) {
  switch (type) {
    case "Compréhension écrite":
      return "CE";
    case "Compréhension orale":
      return "CO";
    case "Production écrite":
      return "PE";
    case "Production orale":
      return "PO";
    default:
      return "";
  }
}

function formatType(type) {
  const map = {
    "PE": "Production Écrite",
    "PO": "Production Orale",
    "CE": "Compréhension Écrite",
    "CO": "Compréhension Orale",
  }
  return map[type];
}

export const DataFormat = {
  Produits(produits) {
    // Inject the first exercice in the produit
    return produits.map((r) => {
      return {
        ...r, ...r.exercices.map(({id, ...other}) => {
          return {
            ...other, exercice: id,
          }
        })[0],
      }
    });
  },
  RandomString(length = 8) {
    // Declare all characters
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    // Pick characers randomly
    let str   = '';
    for (let i = 0; i < length; i++) {
      str += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return str;
  },
  Exercices: _buildExerciceData(),
  Textes   : {
    GetStatus(st1 = 0, st2 = 1, st3 = 2) {
      return (id, fini, corrige) => (LocalID.isLocalID(id) || !fini) ? st1 : (corrige ? st3 : st2);
    },
    Status: [
      {
        text   : "",
        value  : 0,
        variant: ""
      },
      {
        get text() {
          return Auth.IsTeacher() ? "envoyé" : "à faire";
        },
        value  : 1,
        variant: "warning"
      }, {
        get text() {
          return Auth.IsTeacher() ? "à corriger" : "fini";
        },
        value  : 2,
        variant: "success"
      }, {
        text   : "corrigé",
        value  : 3,
        variant: "primary"
      },
    ]
  },
  Eleves   : {
    Roles : [1, 2, 3, 4],
    Labels: {
      Roles: {1: "Visiteur", 2: "Eleve", 3: "Professeur", 4: "Admin"}
    }
  }
}

function _buildExerciceData() {
  const Type         = ['CO', 'CE', 'PO', 'PE'];
  const Niveau       = ['C2', 'C1', 'B2', 'B1', 'A2', 'A1', 'Prep', 'Aut'];
  const NiveauLabels = {
    Aut : "Autre",
    Prep: "Preparation",
    A1  : "A1",
    A2  : "A2",
    B1  : "B1",
    B2  : "B2",
    C1  : "C1",
    C2  : "C2",
  }
  return {
    Type   : ['CO', 'CE', 'PO', 'PE'],
    Niveau,
    Labels : {
      Niveau: {
        ...NiveauLabels,
        All: Niveau.map(n => NiveauLabels[n])
      }
    },
    Options: {
      Niveau: Niveau.map(n => {return {text: NiveauLabels[n], value: n}}),
      Type  : Type.map(n => {return {text: n, value: n}})
    }
  }
}

export {
  getContent,
  getRangeContent,
  getTrimSelection,
  replaceElem,
  addCorrection,
  htmlToLines,
  getType,
  formatType,
}